import { get, isAPIError } from '@user/store/services/crud'
import { toast } from '@sales-center/components'
import { filtersUrl } from '../ActivityHistory/constants'
import {
  initialState,
  fetchAllActivityHistoryFiltersActionCreator,
} from '../state'

export async function fetchAllActivityHistoryFilters() {
  const response = await get(filtersUrl)
  const result = await response.json()

  if (!response.ok) {
    if (isAPIError(result.payload)) {
      toast.error(result.payload.Message)
    } else {
      toast.error('Failed to load Activity History Filters')
    }
    return fetchAllActivityHistoryFiltersActionCreator(initialState.filters)
  }

  return fetchAllActivityHistoryFiltersActionCreator(result)
}
